import Accordion from './src/components/Accordion/index';
import AlertBarModified from './src/components/AlertBarModified/index';
import AlternatingTextAndImage from './src/components/AlternatingTextAndImage/index';
import ButtonList from './src/components/ButtonList/index';
import Carousel from './src/components/TextAndSlider/Carousel';
import CarouselItem from './src/components/CarouselItem/index';
import Container from './src/components/Container/index';
import CtaBar from './src/components/CtaBar/index';
import CtaInline from './src/components/CtaInline/index';
import CtaSearch from './src/components/CtaSearch/index';
import CustomBlogRollTile from './src/components/CustomBlogRoll/CustomBlogRollTile';
import CustomFilterBar from './src/components/CustomBlogRoll/CustomFilterBar';
import CustomFilterBarAlt from './src/components/CustomBlogRoll/CustomFilterBarAlt';
import CustomBlogRoll from './src/components/CustomBlogRoll/index';
import Pagination from './src/components/CustomBlogRoll/Pagination';
import Footer from './src/components/Footer/index';
import Nav from './src/components/Footer/Nav';
import Form from './src/components/Form/index';
import GalleryCarousel from './src/components/GalleryCarousel/index';
import AccordionNav from './src/components/Header/AccordionNav';
import Header from './src/components/Header/index';
import NavMobile from './src/components/Header/NavMobile';
import HeroBanner from './src/components/HeroBanner/index';
import ImageBar from './src/components/ImageBar/index';
import LinkGroup from './src/components/LinkGroup/index';
import LogoBar from './src/components/LogoBar/index';
import MainHeroBanner from './src/components/MainHeroBanner/index';
import Offcanvas from './node_modules/tbk-components/src/components/Offcanvas/Offcanvas.js';
import Newsletter from './src/components/Newsletter/index';
import PrettyPDF from './src/components/PrettyPDF/index';
import ResponsiveSpacer from './src/components/ResponsiveSpacer/index';
import SearchTool from './src/components/SearchTool/index';
import SocialIcons from './src/components/SocialIcons/index';
import Team from './src/components/Team/index';
import TestimonialCarousel from './src/components/TestimonialCarousel/index';
import TextAndSlider from './src/components/TextAndSlider/index';
import SliderItem from './src/components/TextAndSlider/SliderItem';
import AlertBar from './node_modules/tbk-components/src/components/AlertBar/index.js';
import BlogRollFilterBar from './node_modules/tbk-components/src/components/BlogRoll/BlogRollFilterBar.js';
import BlogRollHero from './node_modules/tbk-components/src/components/BlogRoll/BlogRollHero.js';
import BlogRollPage from './node_modules/tbk-components/src/components/BlogRoll/BlogRollPage.js';
import BlogRollPagination from './node_modules/tbk-components/src/components/BlogRoll/BlogRollPagination.js';
import BlogRollSingle from './node_modules/tbk-components/src/components/BlogRoll/BlogRollSingle.js';
import BlogRollTile from './node_modules/tbk-components/src/components/BlogRoll/BlogRollTile.js';
import BlogRoll from './node_modules/tbk-components/src/components/BlogRoll/index.js';
import Button from './node_modules/tbk-components/src/components/Button/index.js';
import ImageAndContent from './node_modules/tbk-components/src/components/ImageAndContent/index.js';
import OffcanvasBackButton from './node_modules/tbk-components/src/components/Offcanvas/OffcanvasBackButton.js';
import OffcanvasButton from './node_modules/tbk-components/src/components/Offcanvas/OffcanvasButton.js';
import RawHTML from './node_modules/tbk-components/src/components/RawHTML/index.js';
import Row from './node_modules/tbk-components/src/components/Row/index.js';

const components = {
	Accordion,
	AlertBarModified,
	AlternatingTextAndImage,
	ButtonList,
	Carousel,
	CarouselItem,
	Container,
	CtaBar,
	CtaInline,
	CtaSearch,
	CustomBlogRollTile,
	CustomFilterBar,
	CustomFilterBarAlt,
	CustomBlogRoll,
	Pagination,
	Footer,
	Nav,
	Form,
	GalleryCarousel,
	AccordionNav,
	Header,
	NavMobile,
	HeroBanner,
	ImageBar,
	LinkGroup,
	LogoBar,
	MainHeroBanner,
	Offcanvas,
	Newsletter,
	PrettyPDF,
	ResponsiveSpacer,
	SearchTool,
	SocialIcons,
	Team,
	TestimonialCarousel,
	TextAndSlider,
	SliderItem,
	AlertBar,
	BlogRollFilterBar,
	BlogRollHero,
	BlogRollPage,
	BlogRollPagination,
	BlogRollSingle,
	BlogRollTile,
	BlogRoll,
	Button,
	ImageAndContent,
	OffcanvasBackButton,
	OffcanvasButton,
	RawHTML,
	Row
};

export default components;
